export enum ClientUserAccessType {
    masterClientUser = 'masterClientUser',
    clientUser = 'clientUser',
    brandClientUser = 'brandClientUser',
    regionalClientUser = 'regionalClientUser',
    hotelUser = 'hotelUser',
}
